import dayjs from 'dayjs'
import { useRouter } from 'next/router'
import { FC, Fragment, useState } from 'react'

import { RequestCommentEntity } from '@/api/models/requests'
import { isUrlAllowed } from '@/utils/url'

import { CommentsServerMessage } from './CommentsServerMessage'
import { CommentsUserMessage } from './CommentsUserMessage'
import { RedirectModal } from './RedirectModal'

type Props = {
  messages: RequestCommentEntity[]
}

export const CommentsMessagesController: FC<Props> = ({ messages }) => {
  const router = useRouter()
  const [isModalOpened, setIsModalOpened] = useState(false)
  const [selectedLink, setSelectedLink] = useState('')

  const handleLink = (url: string) => {
    if (isUrlAllowed(url)) {
      router.replace(url)
    } else {
      setIsModalOpened(true)
      setSelectedLink(url)
    }
  }

  const isDateOmit = (
    message: RequestCommentEntity,
    index: number,
    period: string
  ) => {
    const nextMessage = index < messages.length ? messages[index + 1] : false
    if (!nextMessage || nextMessage.sentByClient !== message.sentByClient) {
      return true
    }

    const messageDate = message.createdAt
    const nextMessageDate = nextMessage.createdAt

    return (
      dayjs(messageDate).format(period) !==
      dayjs(nextMessageDate).format(period)
    )
  }

  return (
    <>
      <div className="flex flex-col">
        {messages.map((message, index) => (
          <Fragment key={message.id + index}>
            {message.sentByClient ? (
              <CommentsUserMessage
                message={message.message}
                file={message.file || undefined}
                date={message.createdAt}
                onLinkClick={handleLink}
                withDate={isDateOmit(message, index, 'YYYY-MM-DD/HH:mm')}
              />
            ) : (
              <CommentsServerMessage
                message={message.message}
                file={message.file || undefined}
                date={message.createdAt}
                authorName={message.authorName}
                onLinkClick={handleLink}
                withDate={isDateOmit(message, index, 'YYYY-MM-DD/HH:mm')}
                withLogo={isDateOmit(message, index, 'YYYY-MM-DD')}
              />
            )}
          </Fragment>
        ))}
      </div>
      <RedirectModal
        opened={isModalOpened}
        onClose={() => setIsModalOpened(false)}
        url={selectedLink}
      />
    </>
  )
}

export default CommentsMessagesController
